import React from 'react';
import { A, Icon } from '@rebrandly/styleguide'
const NavLink = ({
                     href,
                     children,
                     activeLink,
                     setActiveLink,
                     icon,
                     className
                 }) => {
    const isActive = activeLink === href;

    const getClassName = () => {
        const baseClasses = className;
        const activeClass = isActive ? ' active' : '';
        return `${baseClasses}${activeClass}`;
    };
    return (
        <A
            className={getClassName()}
            size='lg'
            rel='noopener noreferrer'
            href={href}
            onClick={() => setActiveLink(href)}
        >
            {icon && (
                <Icon className='p-r-8' name={icon} color='var(--color-black)' />
            )}
            {children}
        </A>
    );
};
export default NavLink;